import React from 'react';
import { Typography, Layout } from 'antd';

const { Title, Paragraph } = Typography;
const { Content } = Layout;

const PrivacyPolicy = () => {
    return (
        <Layout style={{ padding: '24px', maxWidth: '900px', margin: '0 auto' }}>
            <Content>
                <Typography>
                    <Title>Política de Privacidade</Title>
                    <Paragraph><strong>Última atualização:</strong> 13/07/2025</Paragraph>

                    <Paragraph>
                        Esta Política de Privacidade descreve como coletamos, usamos e protegemos as informações dos usuários do nosso aplicativo que tem como objetivo mostrar restaurantes próximos com base na localização.
                    </Paragraph>

                    <Title level={3}>1. Informações Coletadas</Title>
                    <Paragraph>
                        Nosso aplicativo <strong>não coleta nem armazena informações pessoais identificáveis</strong> dos usuários, como nome, e-mail ou número de telefone.
                    </Paragraph>
                    <Paragraph>
                        Coletamos apenas a <strong>localização geográfica aproximada</strong> (latitude e longitude) para exibir os restaurantes mais próximos.
                    </Paragraph>

                    <Title level={3}>2. Uso das Informações</Title>
                    <Paragraph>
                        A localização é usada apenas para:
                        <ul>
                            <li>Exibir restaurantes próximos ao usuário;</li>
                            <li>Calcular distâncias entre o usuário e os restaurantes.</li>
                        </ul>
                        A localização <strong>não é vinculada à identidade do usuário</strong> e não é armazenada após o uso.
                    </Paragraph>

                    <Title level={3}>3. Compartilhamento de Informações</Title>
                    <Paragraph>
                        Não compartilhamos, vendemos ou transferimos qualquer dado de localização com terceiros.
                    </Paragraph>

                    <Title level={3}>4. Permissões</Title>
                    <Paragraph>
                        O aplicativo solicita permissão para acessar a localização do dispositivo somente enquanto estiver em uso. Esta permissão pode ser alterada nas configurações do dispositivo.
                    </Paragraph>

                    <Title level={3}>5. Segurança</Title>
                    <Paragraph>
                        Embora não armazenemos dados pessoais, adotamos boas práticas de segurança para proteger os dados temporários utilizados durante a navegação.
                    </Paragraph>

                    <Title level={3}>6. Direitos do Usuário</Title>
                    <Paragraph>
                        Você pode revogar a permissão de localização a qualquer momento nas configurações do seu celular.
                    </Paragraph>

                    <Title level={3}>7. Alterações nesta Política</Title>
                    <Paragraph>
                        Esta política pode ser atualizada periodicamente. Em caso de alterações significativas, notificaremos você dentro do aplicativo.
                    </Paragraph>

                    <Title level={3}>8. Contato</Title>
                    <Paragraph>
                        Se tiver dúvidas, entre em contato com nossa equipe pelo e-mail: <a href="mailto:contato@telabite.com">contato@telabite.com</a>.
                    </Paragraph>
                </Typography>
            </Content>
        </Layout>
    );
};

export default PrivacyPolicy;
